export abstract class ElementNode {
    #owner: string;
    constructor(opts: { owner: string }) {
        this.#owner = opts.owner;
    }

    public get owner(): string {
        return this.#owner;
    }

    public abstract get isValid(): boolean;
    public abstract get content(): string | null;
    public abstract get [Symbol.toStringTag](): string;
    public abstract downloadContent(options?: RequestInit): Promise<string>;
    public abstract toString(): string;
}
